<template>
  <div>
    <el-menu
      mode="horizontal"
      background-color="#2A8AE0"
      text-color="#FFFFFF"
      :router="true"
      :default-active="activePath"
      class="hori-center"
    >
      <el-menu-item
        v-for="item in navList"
        :key="item.index"
        :index="item.index"
        class="item"
        >{{ item.label }}</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        { label: "首页", index: "/home" },
        { label: "招聘活动", index: "/recruitmentActivity" },
        // { label: "岗位列表", index: "/postList" },
        { label: "求职进度", index: "/jobProgress" },
        { label: "个人中心", index: "/personCenter" }
      ],
      activePath: ""
    };
  },

  watch: {
    $route: {
      handler() {
        this.activePath = this.$route.path;
      },
      immediate: true
    }
  },
  methods: {}
};
</script>
<style>
.el-menu.el-menu--horizontal {
  border-bottom: 0px !important;
}
.el-menu-item.is-active {
  background-color: #1e6eb9 !important;
  color: #ffffff !important;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.hori-center {
  display: flex;
  justify-content: space-around;
  .item {
    width: 15%;
    text-align: center;
    font-size: 20px;
  }
}
</style>
